import EmbeddedGroupLayoutViewModelT from '@/ViewModels/Controls/EmbeddedGroupLayoutViewModel';
import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedGroupLayout from '@/Controls/EmbeddedGroupLayout';

export default class EmbeddedGroupLayoutFactory extends AsyncLayoutFactory {
    public viewModel: EmbeddedGroupLayoutViewModelT;
    private jQueryControl: JQuery;
    private control: EmbeddedGroupLayout;
    private EmbeddedGroupLayoutViewModel = ComponentManager.getViewModel<typeof EmbeddedGroupLayoutViewModelT>('EmbeddedGroupLayoutViewModel');
    private EmbeddedGroupLayout = ComponentManager.getControl<typeof EmbeddedGroupLayout>('EmbeddedGroupLayout');

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = new this.EmbeddedGroupLayoutViewModel({
            tuples: this.tuples,
            labelColumnWidth: this.context.labelColumnWidth
        });
        this.control = new this.EmbeddedGroupLayout(this.viewModel);
        const tuple = await this.control.getTupleAsync();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('EmbeddedGroupLayout', EmbeddedGroupLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');